<div class="container">
  @if (showNavigation) {
    <div class="sidenav">
      <div class="nav-pane nav-pane--root" [class.nav-pane--collapsed]="isRootNavCollapsed">
        <mat-nav-list>
          @for (item of navItems; track item) {
            <app-nav-item
              [item]="item"
              (click)="handleRootNavItemClick(item)"
              [compact]="isRootNavCollapsed"
              [class.active-parent]="isActiveParent(item)"
              >
            </app-nav-item>
          }
        </mat-nav-list>
        @if (!showChildNav) {
          <ng-container *ngTemplateOutlet="toggleButton"></ng-container>
        }
      </div>
      @if (showChildNav) {
        <div class="nav-pane nav-pane--child">
          <mat-nav-list>
            @for (item of selectedParent.children; track item) {
              <app-nav-item [item]="item" [compact]="false">
              </app-nav-item>
            }
          </mat-nav-list>
          <ng-container *ngTemplateOutlet="toggleButton"></ng-container>
        </div>
      }
    </div>
  }

  <div class="content" cdkScrollable>
    <ng-content></ng-content>
  </div>
</div>

<ng-template #toggleButton>
  <button
    type="button"
    class="toggle-button"
    [class.toggle-button--collapse]="canCollapse"
    (click)="toggleCollapse()"
    >
  </button>
</ng-template>
